module.exports = __webpack_public_path__ + "static/media/C_A.96c0c2ac.png";